import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-rx-confirm-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p class="rx-confirm-message">{{ data.message }}</p>
      <mat-form-field *ngIf="data.requireTyped" appearance="fill" class="rx-confirm-typed">
        <mat-label>Type {{ data.requireTyped }} to confirm</mat-label>
        <input matInput autocomplete="off" [formControl]="typed">
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close(false)">CANCEL</button>
      <button
        mat-raised-button
        color="warn"
        type="button"
        [disabled]="!canConfirm"
        (click)="dialogRef.close(true)"
      >
        {{ data.confirm || 'CONFIRM' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .rx-confirm-message {
        margin: 0;
        font-size: 13px;
        line-height: 1.4;
      }
      .rx-confirm-typed {
        width: 100%;
        margin-top: 12px;
      }
    `,
  ],
})
export class RxConfirmDialogComponent {
  typed = new FormControl('');

  constructor(
    public dialogRef: MatDialogRef<RxConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      confirm?: string;
      requireTyped?: string;
    }
  ) {}

  get canConfirm(): boolean {
    const required = String(this.data?.requireTyped || '').trim();
    if (!required) {
      return true;
    }
    return String(this.typed.value || '').trim().toUpperCase() === required.toUpperCase();
  }
}

@Component({
  selector: 'app-rx-image-viewer-dialog',
  template: `
    <h2 mat-dialog-title>RX IMAGE</h2>
    <mat-dialog-content>
      <img class="rx-viewer-image" [src]="data.image" alt="Uploaded RX">
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">CLOSE</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .rx-viewer-image {
        display: block;
        max-width: 80vw;
        max-height: 80vh;
        margin: 0 auto;
      }
    `,
  ],
})
export class RxImageViewerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RxImageViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { image: string }
  ) {}
}
